// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"9286648aa6a6c779f6ad","678":"899a6e00773b328b2514","883":"222d8d36ad4c5da4a00d"}[chunkId] + ".js";
};